module.exports = __webpack_public_path__ + "img/bg-pc.ab844774.png";